module.exports = __webpack_public_path__ + "static/news02.e1e69e82.jpg";